import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { useGetAdminDashboardData } from '@/hooks/api/use-get-admin-dashboard-data';
import { ROUTES } from '@/router/routes';
import { useUserProfile } from '@/states/user-profile';

import { CaseChart } from '@/components/admin/dashboard/chart';
import { CaseFiltersProps, Filters } from '@/components/admin/dashboard/filters';
import { FetchStates } from '@/components/fetch-states';

import { DashboardModule } from './dashboard-module';

export function CasesChartModule() {
  const { profile } = useUserProfile();
  const isVitaziAdmin = profile.role === 'vitaziadmin';

  const [dateRange] = useState({ start: new Date(), end: new Date() });
  const [filters, setFilters] = useState<CaseFiltersProps['filters']>({ site: 'not-specified' });

  const { data: cases, loading, refetchCases } = useGetAdminDashboardData({ dateRange, filters });

  const { t } = useTranslation();

  useEffect(() => {
    if (profile.clinic) {
      setFilters((filter) => ({ ...filter, clinic: profile.clinic }));
    }
  }, [profile.clinic]);

  return (
    <DashboardModule
      title={t('admin-dashboard-title')}
      fullscreenRoute={ROUTES.DASHBOARD_CASES_CHART}
    >
      <div className="space-y-4">
        <div className="w-full">
          <Filters filters={filters} onChange={setFilters} isVitaziAdmin={isVitaziAdmin} />
        </div>
        <FetchStates loading={loading} refetch={refetchCases} empty={!cases?.length}>
          <div className="h-[250px]">
            <CaseChart data={cases} />
          </div>
        </FetchStates>
      </div>
    </DashboardModule>
  );
}
